import React from 'react'
import { Box } from '@mui/material';

import TitleUploaded from "../../../../TitleUploaded"
import FormPeqProveedor from './FormPeqProveedor';
import Navbar from '../../../../Navbar';

function EditarPequeñoProveedor(props) {
    const { row } = props;

    const handleCloseAddProveedor = () => {
        window.location.reload();
    };

    return (
        <div>
            <Box px={2}>
                <TitleUploaded title="Editar Proveedor" handleClose={handleCloseAddProveedor} />
            </Box>
            <FormPeqProveedor
                proveedor={row}
                edicion={true}
                titulo={row.razon_social}
                textBtn="Guardar cambios"
                handleCloseAddProveedor={handleCloseAddProveedor}
            />
        </div>
    )
}

export default EditarPequeñoProveedor;

